import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get, useChangeTrackingLens } from '@totalsoft/change-tracking-react';
import { useDirtyFieldValidation } from '@totalsoft/pure-validations-react';
import { useMutation } from 'hooks/apollo';
import { SAVE_TAX_RATE, DELETE_TAX_RATE } from '../mutations';
import { taxRateValidator } from '../validators';
import TaxRateItem from './TaxRateItem';

const TaxRateItemContainer = ({ item, onCancelNew }) => {
  const [taxRateLens, , resetTaxRate] = useChangeTrackingLens(item);
  const taxRate = taxRateLens |> get;
  const [readOnly, setReadOnly] = useState(item.id !== null);
  const [taxRateValidation, validateTaxRate] = useDirtyFieldValidation(taxRateValidator);

  const [saveTaxRate] = useMutation(SAVE_TAX_RATE, {
    onCompleted: _ => {
      setReadOnly(true);
    }
  });

  const [deleteTaxRate] = useMutation(DELETE_TAX_RATE);

  useEffect(() => {
    resetTaxRate(item);
  }, [item, resetTaxRate]);

  useEffect(() => {
    if (!readOnly) validateTaxRate(taxRate);
  }, [taxRate, readOnly, validateTaxRate]);

  const handleSave = useCallback(() => {
    saveTaxRate({ variables: { input: { ...taxRate } } });
  }, [taxRate, saveTaxRate]);

  const handleEditMode = useCallback(() => {
    setReadOnly(false);
  }, []);

  const handleCancel = useCallback(() => {
    if (item.id === null) {
      onCancelNew();
      return;
    }
    resetTaxRate(item);
    setReadOnly(true);
  }, [resetTaxRate, onCancelNew, item]);

  const handleDelete = useCallback(() => {
    deleteTaxRate({ variables: { id: taxRate.id } });
  }, [taxRate, deleteTaxRate]);

  return (
    <TaxRateItem
      taxRate={taxRate}
      taxRateLens={taxRateLens}
      readOnly={readOnly}
      onSave={handleSave}
      onEdit={handleEditMode}
      onCancel={handleCancel}
      onDelete={handleDelete}
      validation={taxRateValidation}
    />
  );
};

TaxRateItemContainer.propTypes = {
  item: PropTypes.object.isRequired,
  onCancelNew: PropTypes.func.isRequired
};

export default TaxRateItemContainer;
